import moment from "moment";
import styled from "styled-components";

interface Props {
    dayNumber: number;
    stationHoursMap: Record<string, string>;
    launchUpdateWorkHours: (workDay: number) => void;
}

export default function WorkHours ({
    dayNumber,
    stationHoursMap,
    launchUpdateWorkHours
}: Props) {

    return (
        <Container onClick={() => launchUpdateWorkHours(dayNumber)}>
            <h4>{moment().day(dayNumber).format('dddd').substring(0, 3)}</h4>
            <h6>{stationHoursMap[dayNumber] || 'NA'}</h6>
        </Container>
    );
}

const Container = styled.div`
    border-radius: 5px;
    background-color: #51c878;
    padding: 10px;
    transition: 200ms;
    width: 121px;
    color: white;

    &:hover {
        cursor: pointer;
        background-color: #33b75f;
    }

    & h4 {
        font-weight: bold;
    }
`;